import React, { useMemo } from 'react';
import { Tag, Typography } from 'antd';
import type { RouteExpense } from '../../../store/api/financeApi';
import {
  buildRouteExpenseTimeline,
  summarizeRouteExpenses
} from '../../finance/domain/routeExpenseProjection';
import { routeExpenseStatusLabel, routeExpenseStatusTagColor } from '../../finance/constants/routeExpenseStatus';
import { routeExpenseTypeLabel } from '../../finance/constants/routeExpenseTypes';

const { Text } = Typography;

type Props = {
  expenses: RouteExpense[];
  loading?: boolean;
};

export const ExecutionExpensePanel: React.FC<Props> = ({ expenses, loading }) => {
  const summary = useMemo(() => summarizeRouteExpenses(expenses), [expenses]);
  const timeline = useMemo(() => buildRouteExpenseTimeline(expenses).slice(0, 6), [expenses]);

  if (loading) {
    return (
      <section className="execution-workspace__expense-panel">
        <Text type="secondary" style={{ fontSize: 12 }}>
          Загрузка расходов…
        </Text>
      </section>
    );
  }

  if (summary.total === 0) {
    return null;
  }

  return (
    <section className="execution-workspace__expense-panel">
      <Text strong style={{ fontSize: 12, display: 'block', marginBottom: 6 }}>
        Доп. расходы
      </Text>
      <div className="execution-workspace__expense-summary-row">
        <Text className="execution-workspace__muted" style={{ fontSize: 11 }}>
          На подтверждении: <Text strong>{summary.pendingApproval}</Text>
          {' · '}
          Подтверждено: <Text strong>{summary.confirmed}</Text>
          {' · '}
          Отклонено: <Text strong>{summary.rejected}</Text>
        </Text>
      </div>
      {timeline.length > 0 ? (
        <ul className="execution-workspace__expense-timeline">
          {timeline.map((ev) => (
            <li key={ev.id}>
              <Text style={{ fontSize: 11 }}>
                {new Date(ev.at).toLocaleString('ru-RU', {
                  day: '2-digit',
                  month: '2-digit',
                  hour: '2-digit',
                  minute: '2-digit'
                })}{' '}
                — {ev.label}
                <Text type="secondary"> ({ev.typeLabel})</Text>
              </Text>
            </li>
          ))}
        </ul>
      ) : null}
      <div className="execution-workspace__expense-chips" style={{ marginTop: 6 }}>
        {expenses.slice(0, 4).map((e) => (
          <Tag
            key={e.id}
            color={routeExpenseStatusTagColor(e.status)}
            style={{ marginBottom: 4 }}
          >
            {routeExpenseTypeLabel(e.type)}: {Number(e.amountWithVAT).toLocaleString('ru-RU')} ₽ —{' '}
            {routeExpenseStatusLabel(e.status, 'logist', { persisted: true })}
          </Tag>
        ))}
        {expenses.length > 4 ? (
          <Text type="secondary" style={{ fontSize: 11 }}>
            +{expenses.length - 4}
          </Text>
        ) : null}
      </div>
    </section>
  );
};

export default ExecutionExpensePanel;
